export default (locale: string | null) => {
  if (locale) {
    return import(`../resources/nls/${locale}/bundle.ts`).then((module) => module.default);
  } else {
    return import(`../resources/nls/bundle`).then((module) => module.default);
  }
};
